module.exports = __webpack_public_path__ + "img/processing-security-dss.0c483d4f.svg";